import '../scss/style.scss';
import '../scss/footer.scss';
import '../scss/header.scss';
import '../scss/svg-animate.scss';
import { animateSVGs } from './svg-animate.js';
import { activateFixedNav } from './header.js';

function memberServicesHover() {
  document.querySelectorAll('.custom-hover-section').forEach(section => {
    const h3 = section.querySelector('h3');
    const svg = section.querySelector('.arrow-svg');
    if (!h3 || !svg) return;
    h3.addEventListener('mouseenter', () => svg.classList.add('hover'));
    h3.addEventListener('mouseleave', () => svg.classList.remove('hover'));
    svg.addEventListener('mouseenter', () => h3.classList.add('hover'));
    svg.addEventListener('mouseleave', () => h3.classList.remove('hover'));
  });
}


// iOS does not focus tapped elements, leaving document.activeElement as null.
// Kadence's MicroModal stores document.activeElement on open and later calls
// .closest() on it — crashing with "null is not an object". Focusing the trigger
// button during touchstart (capture phase, before the click fires) fixes this.
function fixKadenceModalIOS() {

  // iOS Safari does not focus tapped elements, so document.activeElement is
  // null or <body> when MicroModal's click handler runs. Kadence's modal JS
  // reads document.activeElement and immediately calls .closest() on it —
  // crashing when it's null. Fix: override document.activeElement via
  // Object.defineProperty in the capture phase (runs before MicroModal's
  // bubble-phase handler) so MicroModal sees the trigger button as activeElement.
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.kt-blocks-modal-link[data-modal-open]');
    if (!trigger) return;

    const ae = document.activeElement;

    if (ae && ae !== document.body) {
      return;
    }

    Object.defineProperty(document, 'activeElement', {
      configurable: true,
      get: () => trigger,
    });

    // Restore the native prototype getter after MicroModal has stored
    // document.activeElement in this.activeElement (synchronous, same tick).
    setTimeout(function () {
      delete document.activeElement;
    }, 0);
  }, { capture: true });
}

// Kadence accordion caches each panel's height in a data-panel-height attribute
// measured once at DOMContentLoaded, before web fonts / images have settled. On
// narrow (tablet/mobile) layouts that first measurement can be too tall, and the
// open animation uses Math.max(scrollHeight, data-panel-height) — so the first
// open over-expands to the stale value then snaps shut (janky). The plugin only
// self-corrects the attribute after a full open→close cycle. Dropping the stale
// value on window.load forces every open to use the live scrollHeight instead.
function fixKadenceAccordionHeight() {
  document
    .querySelectorAll('.kt-accordion-panel[data-panel-height]')
    .forEach(panel => panel.removeAttribute('data-panel-height'));
}

function domInteractive() {
  // document.body.classList.add("loaded");
  let adminNav = document.querySelector('#wpadminbar');
  let adminNavHeight = 0;

  if (adminNav) {
    adminNavHeight = adminNav.clientHeight;
    document.documentElement.style.setProperty("--adminbar-height", `${adminNavHeight}px`);
  }

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    document.body.classList.add('is-safari');
  }

  activateFixedNav();
  memberServicesHover();
  fixKadenceModalIOS();
}

function domLoaded() {
  const scrollBarWidth = (window.innerWidth - document.documentElement.clientWidth);
  document.body.style.setProperty("--scrollbar-offset", `${scrollBarWidth}px`);
  animateSVGs();
  fixKadenceAccordionHeight();
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  domInteractive();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    domInteractive();
  })
}

if (document.readyState === 'complete') {
  domLoaded();
} else {
  window.addEventListener('load', function () {
    domLoaded();
  });
}